// src/i18n/fieldMapping.js
import { getLanguage } from "./languageStore";
import { getOverride } from "./translationsLoader";
import de from "./translations/de";
import en from "./translations/en";
import tr from "./translations/tr";
import pl from "./translations/pl";
import uk from "./translations/uk";
import rentalTr from "./translations/rental";
import listFiltersTr from "./translations/listFilters";
import automationsTr from "./translations/automations";
import liveLocationTr from "./translations/liveLocation";
import adminReportsTr from "./translations/adminReports";
import complaintsTr from "./translations/complaints";
import waypointsTr from "./translations/waypoints";
import cartTr from "./translations/cart";
import tipsTr from "./translations/tips";
import legsTr from "./translations/legs";
import miscTr from "./translations/misc";
import customerTr from "./translations/customer";
import companyTr from "./translations/company";
import seoTr from "./translations/seo";


const extend = (lang, base) => ({ ...base, ...(rentalTr[lang] || {}), ...(listFiltersTr[lang] || {}), ...(automationsTr[lang] || {}), ...(liveLocationTr[lang] || {}), ...(adminReportsTr[lang] || {}), ...(complaintsTr[lang] || {}), ...(waypointsTr[lang] || {}), ...(cartTr[lang] || {}), ...(tipsTr[lang] || {}), ...(legsTr[lang] || {}), ...(miscTr[lang] || {}), ...(customerTr[lang] || {}), ...(companyTr[lang] || {}), ...(seoTr[lang] || {}) });
const fieldMaps = { de: extend("de", de), en: extend("en", en), tr: extend("tr", tr), pl: extend("pl", pl), uk: extend("uk", uk) };

export const getFieldLabel = (field) => {
  const lang = getLanguage();
  // DB-Override hat Vorrang (im Admin-Editor gepflegt), fällt sonst auf die
  // statischen Dateien zurück — auch für Sprachen, die es hier noch gar
  // nicht als eigene Datei gibt.
  const override = getOverride(lang, field);
  if (override) return override;
  const map = fieldMaps[lang] || fieldMaps.de;
  return map[field] || fieldMaps.de[field] || field;
};

export default fieldMaps;

// Menü-Beschriftungen: kurze Texte unter nav_<item_id> bzw. navcat_<Kategorie>; fehlt der Schlüssel, gilt das bisherige Verhalten (Label/Kategorie als Schlüssel bzw. Text).
export const navLabel = (item) => {
  const k = `nav_${item.item_id}`; const v = getFieldLabel(k);
  return v !== k ? v : getFieldLabel(item.label);
};
export const navCategory = (cat) => {
  const k = `navcat_${cat}`; const v = getFieldLabel(k);
  return v !== k ? v : getFieldLabel(cat);
};

// Texte, die als deutscher Klartext aus dem Backend kommen oder fest im Code stehen: Übersetzung unter stx_<Text>; ohne Eintrag bleibt der Text unverändert.
// Schlüssel: stx_<Text>; bei langen Texten (> 200 Zeichen, Spalte hat 255) gekürzt + Länge + Prüfsumme (muss mit der Eintragung in der DB übereinstimmen)
export const stxKey = (t) => {
  if (t.length <= 200) return `stx_${t}`;
  let h = 5381; for (let i = 0; i < t.length; i++) h = (((h * 33) ^ t.charCodeAt(i)) >>> 0);
  return `stx_${t.slice(0, 120)}~${t.length}~${h.toString(36)}`;
};
export const tx = (text) => {
  if (text === null || text === undefined || text === "") return text;
  const k = stxKey(String(text)); const v = getFieldLabel(k);
  return v !== k ? v : text;
};
// Zahlen-/Datumsformat passend zur gewählten Sprache
export const numLocale = () => ({ de: "de-DE", en: "en-GB", tr: "tr-TR" }[getLanguage()] || "de-DE");
// Wie tx(), aber mit Platzhaltern {0}, {1} … für eingesetzte Werte: txf("vor {0} Min.", n)
export const txf = (text, ...args) => String(tx(text)).replace(/\{(\d+)\}/g, (m, i) => (args[Number(i)] === undefined ? m : args[Number(i)]));
